import Web3 from 'web3'

export class Web3Helper {
    public static gweiToWei(x: number): string {
        return Web3.utils.toWei(x.toFixed(5), 'gwei')
    }
}
